export default function (dom, opts) {
    let options = {
        searchInputSel: '[data-zip-input]',
        searchInputContainerSel: '[data-zip-input-container]',
        recipientSel: 'input[name="recipient"]',
				categorySel: 'input[name="contactCategory"]',
        catInputSel: '[data-cat-input]',
        resultsDivSel: '[data-cat-results]',
        resultsShowListSel: '[data-cat-show-results]',
        resultTextIntroSel: '[data-result-text] .welcome-intro',
        resultTextResultSel: '[data-result-text] .result-intro',
        loaderSel: '.loader-anim',
        loaderCls: 'loader-anim--show',
        showCls: 'show',
        ...opts
    };

    const inputSearch = dom.querySelector(options.searchInputSel);
    const searchInputContainer = dom.querySelector(options.searchInputContainerSel);
    const inputCat = dom.querySelector(options.catInputSel);
    const resultsDiv = dom.querySelector(options.resultsDivSel);
    const showResultsList = dom.querySelector(options.resultsShowListSel);
    const resultTextIntro = dom.querySelector(options.resultTextIntroSel);
    const resultTextResult = dom.querySelector(options.resultTextResultSel);
    const loader = dom.querySelector(options.loaderSel);
    const contactForm = document.querySelector('.contact-overlay-box__bottom');
		const supportHint = document.querySelector('.contact-overlay-box__support');
    const contactdefault = dom.querySelector("[contact-default]").innerHTML;
    const recipient = document.querySelector(options.recipientSel);
		const category = document.querySelector(options.categorySel);
    const page = document.querySelector('input[name="page"]');

    let searchTimeout;

    function init() {
        // typing on input
        inputSearch.addEventListener('keyup', (key) => {
            inputActions();
        })

        // enter pressed on input
        inputSearch.addEventListener('keypress', (key) => {
            if (key.key === 'Enter') {
                inputActions(true);
                resultsDiv.classList.add(options.showCls);
            }
        })
        // paste into input event
        inputSearch.addEventListener('paste', (key) => {
            inputActions(true);
            resultsDiv.classList.add(options.showCls);
        })

    }

    function inputActions(ignoreLength = false) {
        // show animation when first typing
        if (inputSearch.value.length > 3) {
            showResultsList.innerHTML = "";
            loader.classList.add(options.loaderCls);
            resultsDiv.classList.add(options.showCls);
        }
        // show animation and remove results div on backspace
        if (inputSearch.value.length >= 4 || ignoreLength) {
            clearTimeout(searchTimeout);
            //slow things down
            searchTimeout = setTimeout(() => {
                searchRequest();
            }, 100)
            //    remove all animations and results div
        } else if (inputSearch.value.length === 0) {
            showResultsList.innerHTML = "";
            loader.classList.add(options.loaderCls);
            resultsDiv.classList.remove(options.showCls);
        }
    }
    function reset() {
        //control displaying
				supportHint.style.display = 'none';
        searchInputContainer.style.display = 'block';
        resultTextResult.style.display = 'none';
        resultTextIntro.style.display = 'block';
        contactForm.style.display = 'none';
        showResultsList.innerHTML = '';
        inputSearch.value = '';
        recipient.value = '';
				category.value = '';
    }

    function searchRequest() {
        const xmlReq = new XMLHttpRequest();
        xmlReq.onreadystatechange = function () {
            if (xmlReq.readyState === 4) {
                if (xmlReq.status === 200) {
                    //decode json results
                    const obj = JSON.parse(this.responseText);
                    console.info(obj);
                    let results = "";

                    if(obj.length < 1) {
                        results = contactdefault;
                    } else {
                        results = `<div><div class="contact-head"><img src="${obj.image}" class="contact-box__content-image"><div><span class="contact-box__content-name">${obj.name}</span><span class="contact-box__content-jobtitle">${obj.jobtitle}</span><span class="contact-box__content-phone"><a href="tel:${obj.phone}">${obj.phone}</a></span></div></div></div>`;
                        recipient.value = obj.email;
												category.value = obj.category;
                    }

                    var introtext = resultTextResult.getAttribute('data-text');
                    var defaultcontact = resultTextResult.getAttribute('data-default');

                    if(obj.name) {
                        resultTextResult.innerHTML = introtext.replace("%s", obj.name);
                    } else {
                        resultTextResult.innerHTML = defaultcontact;
                    }

                    //control displaying
                    searchInputContainer.style.display = 'none';
                    resultTextResult.style.display = 'block';
                    resultTextIntro.style.display = 'none';
                    contactForm.style.display = 'block';
										supportHint.style.display = 'block';

                    //listen to changearea clicks
                    var changearea = dom.querySelector(".change-area");
                    if(changearea) {
                        changearea.addEventListener('click', function(e){
                            reset();
                        });
                    }

                    if (!obj) {
                        // translations from template
                        results = `<div>${options.translation.notFound}</div>`;
                    }
                    showResultsList.innerHTML = results;
                } else {
                    showResultsList.innerHTML = `<div>${options.translation.notFound}</div>`;
                }
                loader.classList.remove(options.loaderCls);
            }
        }

        let url = 'zipsearch?zip=' + inputSearch.value + "&cat=" + inputCat.value;
        let params = '';
        xmlReq.open("GET", url, true);
        xmlReq.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xmlReq.send(params);
    }

    function allResultsPage() {
        location.href = `${options.redirect.url}?${params}`;
    }


    init()

}
